<table class="table tbt bg-white table-border table-hover border-dark">
  <tbody>
    <tr>
      <th style="border-top: 0;">{{'Queue' | translate }}</th>
      <td style="border-top: 0;">
        {{_medicalRepo?.queueNum}}
      </td>
    </tr>
    <tr>
      <th style="border-top: 0;">{{'PatientCode' | translate }}</th>
      <td style="border-top: 0;">
        {{_medicalRepo?.patientCode}}
      </td>
    </tr>
    <tr>
      <th>{{ 'visitNum' | translate }}</th>
      <td>
        {{_medicalRepo?.visitNo}}
      </td>
    </tr>
    <tr>
      <th>{{ 'patient' | translate}}</th>
      <td>
        {{translate.currentLang == 'ar' ? _medicalRepo?.patientNameAr : _medicalRepo?.patientNameEn}}
      </td>
    </tr>
    <tr>
      <th>{{ 'mobile' | translate}}</th>
      <td>
        {{ _medicalRepo?.mobile}}
      </td>
    </tr>
    <tr>
      <th>{{ 'SERVICENAME' | translate }}</th>
      <td>
        {{translate.currentLang == 'ar' ?
        _medicalRepo?.serviceNameAr:_medicalRepo?.serviceNameEn}}
      </td>
    </tr>
    <tr>
      <th>{{ 'ServiceStatus' | translate }}</th>
      <td>
        {{translate.currentLang == 'ar' ?
        _medicalRepo?.serviceStatusAr:_medicalRepo?.serviceStatusEn}}
      </td>
    </tr>
    <tr>
      <th>{{ 'Contract' | translate }}</th>
      <td>
        {{translate.currentLang == 'ar' ?
        _medicalRepo?.contractsAr:_medicalRepo.getPatientInfo?.contractsEn}}
      </td>
    </tr>
    <tr>
      <th>{{ 'ExaminationTime' | translate }}</th>
      <td>
        {{ _medicalRepo?.expectedStartTime | date:'shortTime' }}
      </td>

      <th>{{ 'EndTime' | translate }}</th>
      <td>
        {{ _medicalRepo?.expectedEndTime | date:'shortTime' }}
      </td>
    </tr>
    <tr>
      <th>{{'Payed' | translate }}</th>
      <td>
        <i *ngIf="_medicalRepo?.payed == 1" class="fa fa-check fa-2x" aria-hidden="true"></i>
        <i *ngIf="_medicalRepo?.payed == null" class="fa fa-times fa-2x" aria-hidden="true"></i>
      </td>
    </tr>
    <tr>
      <th>{{ 'DOCTOR' | translate }}</th>
      <td>
        {{translate.currentLang == 'ar' ?
        _medicalRepo?.docNameAr:_medicalRepo?.docNameEn}}
      </td>
    </tr>
    <tr>
      <th>{{ 'ENTERDATE' | translate }}</th>
      <td>
        {{ _medicalRepo?.expectedStartTime | date:'short' }}
      </td>
    </tr>
    <tr>
      <th>{{ 'PLACENAME' | translate }}</th>
      <td>
        {{translate.currentLang == 'ar' ?
        _medicalRepo?.placeNameAr:_medicalRepo?.placeNameEn}}
      </td>
    </tr>
    <tr>
      <th>{{ 'BODYPART' | translate }}</th>
      <td>
        {{ _medicalRepo?.bodyPart}}
      </td>
    </tr>
  </tbody>
</table>